/**
 * "JIGGLING" TRIANGLES / CIRCLES LIST INTERACTION
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise Triangles / Circles
         */
        console.log( 'Triangles / Circles - init' );
       
        var add_triangles_circles_modal_target = '';

        //
        // BUILD / MANAGE DATA ARRAYS CONTENT FOR EACH OF THE THREE TRIANGLE / CIRCLE LISTS.
        //
        // I LOVE...
        this.i_love_array = [];
        // Push to array...
        var pushToILoveArray = ( name, status ) => {
            this.i_love_array.push( { name: name, status: status } );
            console.table( this.i_love_array );
        }
        // Remove from array...
        var removeFromILoveArray = ( id ) => {
            this.i_love_array.splice( id, 1 );
            console.table( this.i_love_array );
        }
        
        var renderDefaultILoveItems = () => {
            this.i_love_array = [];
            $( '#i_love_items_src li' ).each( function( index ) {
                var name = $( this ).text();
                $( this ).attr( 'data-item-array-id', index );
                pushToILoveArray( name, '' );
            });
        }
        renderDefaultILoveItems();
        
        var renderILoveItems = () => {
            this.renderItems( 'i_love_items' );
            console.table( this.i_love_array );
        }
        renderILoveItems();
        console.log( 'this.i_love_array:' );
        
        
        // I WANT TO...
        this.i_want_to_array = [];
        // Push to array...
        var pushToIWantToArray = ( name, status ) => {
            this.i_want_to_array.push( { name: name, status: status } );
            console.table( this.i_want_to_array );
        }
        // Remove from array...
        var removeFromIWantToArray = ( id ) => {
            this.i_want_to_array.splice( id, 1 );
            console.table( this.i_want_to_array );
        }
        
        var renderDefaultIWantToItems = () => {
            this.i_want_to_array = [];
            $( '#i_want_to_items_src li' ).each( function( index ) {
                var name = $( this ).text();
                $( this ).attr( 'data-item-array-id', index );
                pushToIWantToArray( name, '' );

            });
        }
        renderDefaultIWantToItems();
        
        var renderIWantToItems = () => {
            this.renderItems( 'i_want_to_items' );
            console.table( this.i_want_to_array );
        }
        renderIWantToItems();
        console.log( 'this.i_want_to_array:' );
        
        
        // I AM...
        this.i_am_array = [];
        // Push to array...
        var pushToIAmArray = ( name, status ) => {
            this.i_am_array.push( { name: name, status: status } );
            console.table( this.i_am_array );
        }
        // Remove from array...
        var removeFromIAmArray = ( id ) => {
            this.i_am_array.splice( id, 1 );
            console.table( this.i_am_array );
        }
        
        var renderDefaultIAmItems = () => {
            this.i_am_array = [];
            $( '#i_am_items_src li' ).each( function( index ) {
                var name = $( this ).text();
                $( this ).attr( 'data-item-array-id', index );
                pushToIAmArray( name, '' );

            });
        }
        renderDefaultIAmItems();
        
        var renderIAmItems = () => {
            this.renderItems( 'i_am_items' );
            console.table( this.i_am_array );
        }
        renderIAmItems();
        console.log( 'this.i_am_array:' );
        
        
        // Delete item...
        var deleteItem = ( list_id, array_id ) => {
            // Delete item from array...
            if ( list_id == 'i_love_items' ) {
                removeFromILoveArray( array_id );
                renderILoveItems();
            } else if ( list_id == 'i_want_to_items' ) {
                removeFromIWantToArray( array_id );
                renderIWantToItems();
            } else if ( list_id == 'i_am_items' ) {
                removeFromIAmArray( array_id );
                renderIAmItems();
            }
        }
        
        
        $( 'body' ).on( 'click', '.triangles li div, .circles li div', function( event ) {
            $( this ).addClass( 'popped' );
            var list_id = $( this ).parent().parent().attr( 'id' );
            var array_id = $( this ).children( 'a' ).attr( 'data-item-array-id' );
            $( this ).parent().fadeOut( 400 , function() {
                deleteItem( list_id, array_id );
            });
            
            event.preventDefault();
        });

        // Reset items to default set...
        $( '.reset' ).on( 'click', function( event ) {
            var list_id = $( this ).parent( '.triangles_circles_selector' ).children( '.render_list' ).attr( 'id' );
            //$( this ).parent().children( 'ul' ).children( 'li.custom' ).remove();
            //$( this ).parent().children( 'ul' ).children( 'li' ).children( 'div' ).removeClass( 'popped' );
            //$( this ).parent().children( 'ul' ).children( 'li' ).fadeIn( 400 );
            if ( list_id == 'i_love_items' ) {
                renderDefaultILoveItems();
                renderILoveItems();
                
            } else if ( list_id == 'i_want_to_items' ) {
                renderDefaultIWantToItems();
                renderIWantToItems();
                
            } else if ( list_id == 'i_am_items' ) {
                renderDefaultIAmItems();
                renderIAmItems();
            }
            
            event.preventDefault();
        });

        // Add new - open modal event
        $( '#add_new_triangle_circle_modal' ).on( 'open.zf.reveal', function() {
            $( '#add_new_triangle_circle_modal input' ).val( '' );
            $( '#add_new_triangle_circle_modal input' ).focus();
            console.log( 'add_new_triangle_circle_modal open' );
        });

        // Add new - close modal event
        $( '#add_new_triangle_circle_modal' ).on( 'closed.zf.reveal', function() {
            $( '#add_new_triangle_circle_modal input' ).val( '' );
            add_triangles_circles_modal_target = '';
            console.log( 'add_new_triangle_circle_modal close' );
        });

        // Add new - open modal
        $( '.triangles_circles_selector .add' ).on( 'click', function( event ) {
            add_triangles_circles_modal_target = $( this ).siblings( 'ul.render_list' );
            console.log( add_triangles_circles_modal_target );
            event.preventDefault();
        });

        // Add new - click on save button in modal
        $( '#save_add_new_triangle_circle' ).on( 'click', function( event ) {
            var triangle_circle_item = aon_craft_utils.removeHTMLTags( $( '#add_new_triangle_circle_modal input' ).val() );
            console.log( add_triangles_circles_modal_target.attr( 'id' ) + ' --- ' + triangle_circle_item );
            if ( triangle_circle_item !== '' ) {
                // Add Item to Array...
                var list_id = add_triangles_circles_modal_target.attr( 'id' );
                console.log( 'list_id: ' + list_id );
                if ( list_id == 'i_love_items' ) {
                    pushToILoveArray( triangle_circle_item, 'custom' );
                    renderILoveItems();
                    
                } else if ( list_id == 'i_want_to_items' ) {
                    pushToIWantToArray( triangle_circle_item, 'custom' );
                    renderIWantToItems();
                    
                } else if ( list_id == 'i_am_items' ) {
                    pushToIAmArray( triangle_circle_item, 'custom' );
                    renderIAmItems();
                    
                } else {
                    console.log( 'No matching list_id' );
                }
            }
            event.preventDefault();
        });

    },
    
    loadUserArrayItems( list_id, list_array ) {
        if ( list_id == 'i_love_items' ) {
            this.i_love_array = list_array;
            this.renderItems( list_id );

        } else if ( list_id == 'i_want_to_items' ) {
            this.i_want_to_array = list_array;
            this.renderItems( list_id );

        } else if ( list_id == 'i_am_items' ) {
            this.i_am_array = list_array;
            this.renderItems( list_id );

        }
    },
    
    renderItems( list_id ) {
        console.log( 'renderItems: ' + list_id );
        // Remove any existing entries so that we don't re-render...
        $( '#' + list_id + ' li' ).remove();
   
        if ( list_id == 'i_love_items' ) {
            var render_array = this.i_love_array;

        } else if ( list_id == 'i_want_to_items' ) {
            var render_array = this.i_want_to_array;

        } else if ( list_id == 'i_am_items' ) {
            var render_array = this.i_am_array;

        }
        
        //var render_array = list_array;
        
        // Loop over entries array...
        var entry_count = 1;
        $.each( render_array, function( index ) {
            console.log( 'rendering...' );
            var animClass = 'anim_1';
            if ( index % 2 == 0 ) {
                animClass = 'anim_1';
            } else {
                animClass = 'anim_2';    
            }
            $( this ).addClass( animClass );
            $( '#' + list_id ).append( '<li><div class="' + animClass + '"><a href="#" data-item-array-id="' + index + '">' + this.name + '</a></div></li>' );
            entry_count++;
        });
        
    },
    
    getArrayData( list_array ) {
        if ( list_array == 'i_love_items' ) {
            //var i_love_array = JSON.stringify( this.i_love_array );
            return this.i_love_array;

        } else if ( list_array == 'i_want_to_items' ) {
            //var i_want_to_array = JSON.stringify( this.i_want_to_array );
            return this.i_want_to_array;

        } else if ( list_array == 'i_am_items' ) {
            //var i_am_array = JSON.stringify( this.i_am_array );
            return this.i_am_array;

        }
        
    }
  
}